import { UserProfileModel } from '../../models/user-profile.model';
import { ProfileCheckModel } from '../../models/profile-check.model';
import { EnvironmentSettingsModel } from '../../models/environment-settings.model';
import { LocaleModel } from 'src/app/shared/models/locale.model';
import { UserAppModel } from 'src/app/auth/models/user-app.model';

export class AuthStateModel {
    environmentSettings?: EnvironmentSettingsModel;
    loading: boolean;
    loggedIn?: boolean;
    userProfile?: UserProfileModel;
    profileCheck?: ProfileCheckModel;

    userLocale: LocaleModel;
    userApps?: UserAppModel[];
    selectedAppId?: number;
}
